import { useHttp } from "./useHttp";
import { useDispatch } from "react-redux";
import { createSetTransactionReportingCategoriesDataAction } from "../actions/dataActions";
import {useGetAndSet} from "./useGetAndSet";

export const useTransactionReportingCategoryData = (params, dataFresh) => {
  // const dispatch = useDispatch();
  // const [data, loading, error] = useHttp(
  //   "transactionreportingcategory",
  //   "get",
  //   params,
  //   dataFresh
  // );
  // if (error) {
  //   throw Error("There was an error");
  // }
  //
  // if (!loading && data !== null) {
  //   dispatch(createSetTransactionReportingCategoriesDataAction(data));
  // }
  //
  // return !loading;
  return useGetAndSet("transactionreportingcategory", params, createSetTransactionReportingCategoriesDataAction, dataFresh)
};
